import * as React from "react";
import { forwardRef } from "react";
const SvgArrowUp = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12.0024 8.94665L17.6562 14.6005L16.6024 15.6543L12.0024 11.0543L7.40242 15.6543L6.3486 14.6005L12.0024 8.94665Z", fill: "black" }));
const ForwardRef = forwardRef(SvgArrowUp);
export default ForwardRef;
